import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Button,
    Typography,
    Divider,
    Grid,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export default function DistanceSellingAgreement({
    open,
    onClose,
    markaUnvan = "",
    markaMersisVno = "",
    markaAdres = "",
    markaTemsilciAdSoyad = "",
    markaEposta = "",
    markaTel = "",
}) {
    const Section = ({ title, children, id }) => (
        <Box id={id} sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
                {title}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box>{children}</Box>
        </Box>
    );

    const InfoRow = ({ label, value }) => (
        <Grid container spacing={1} sx={{ mb: 0.5 }}>
            <Grid item xs={4} sm={3} md={2}>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={8} sm={9} md={10}>
                <Typography variant="body2">{value}</Typography>
            </Grid>
        </Grid>
    );

    const Ek1Perakende = (
        <Table size="small" sx={{ mt: 1 }}>
            <TableHead>
                <TableRow>
                    <TableCell>Paket</TableCell>
                    <TableCell>Ön Ödeme/Bakiye</TableCell>
                    <TableCell>Hediye Medya</TableCell>
                    <TableCell>Görünürlük</TableCell>
                    <TableCell>Alt Reklam</TableCell>
                    <TableCell>Influencer / UGC</TableCell>
                    <TableCell>Raporlama</TableCell>
                    <TableCell>Komisyon</TableCell>
                    <TableCell>GMV Tavanı</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>Başlangıç Modeli (Komisyon)</TableCell>
                    <TableCell>Ön ödeme yok</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>Rapor + duygu analizi</TableCell>
                    <TableCell>%10 + KDV</TableCell>
                    <TableCell>Sınırsız</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Başlangıç Paketi</TableCell>
                    <TableCell>50.000 TL + KDV</TableCell>
                    <TableCell>1 Hafta Açıkhava (1.812 ekran – 12M)</TableCell>
                    <TableCell>7 gün ana sayfa & kategori</TableCell>
                    <TableCell>500 gösterim</TableCell>
                    <TableCell>3 UGC</TableCell>
                    <TableCell>Rapor + duygu analizi</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>~440.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Büyüme Paketi</TableCell>
                    <TableCell>110.000 TL + KDV</TableCell>
                    <TableCell>1 Hafta Açıkhava (46 ekran – 8M)</TableCell>
                    <TableCell>14 gün ana sayfa & kategori</TableCell>
                    <TableCell>1.500 gösterim</TableCell>
                    <TableCell>7 UGC</TableCell>
                    <TableCell>Rapor + duygu analizi</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>~1.100.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Premium Paket</TableCell>
                    <TableCell>187.000 TL + KDV</TableCell>
                    <TableCell>1H Açıkhava (34 ekran – 43M) + 1H ATM (44 ekran – 27M)</TableCell>
                    <TableCell>30 gün hero + kategori dominasyonu</TableCell>
                    <TableCell>3.500 gösterim</TableCell>
                    <TableCell>20 UGC</TableCell>
                    <TableCell>İleri rapor + brand-lift</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>~1.870.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Custom</TableCell>
                    <TableCell>Esnek</TableCell>
                    <TableCell>Kombinasyon</TableCell>
                    <TableCell>Özel</TableCell>
                    <TableCell>Esnek</TableCell>
                    <TableCell>Özel</TableCell>
                    <TableCell>Özel rapor</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>Belirlenecek</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );

    const Ek2Lokal = (
        <Table size="small" sx={{ mt: 1 }}>
            <TableHead>
                <TableRow>
                    <TableCell>Paket</TableCell>
                    <TableCell>Bakiye</TableCell>
                    <TableCell>Hediye Medya</TableCell>
                    <TableCell>Uygulama İçi</TableCell>
                    <TableCell>Reklam Desteği</TableCell>
                    <TableCell>Raporlama</TableCell>
                    <TableCell>Komisyon</TableCell>
                    <TableCell>GMV Tavanı</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>Komisyon Bazlı</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>100 alt reklam</TableCell>
                    <TableCell>Sınırsız kampanya</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>Rapor + duygu analizi</TableCell>
                    <TableCell>%10 + KDV</TableCell>
                    <TableCell>Sınırsız</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Büyüme Paketi</TableCell>
                    <TableCell>50.000 TL + KDV</TableCell>
                    <TableCell>1H Metro (1.812 ekran – 12M)</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>7.500 TL Meta (%15)</TableCell>
                    <TableCell>Rapor + duygu analizi</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>~500.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Prestij Paketi</TableCell>
                    <TableCell>100.000 TL + KDV</TableCell>
                    <TableCell>1H Seaplay (46 ekran – 8M) + 1H ATM (44 ekran – 27M)</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>15.000 TL Meta (%15)</TableCell>
                    <TableCell>Rapor + duygu analizi</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>~1.000.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Premium Paket</TableCell>
                    <TableCell>187.000 TL + KDV</TableCell>
                    <TableCell>1H Full Network (34 ekran – 43M) + 1H ATM (44 ekran – 27M)</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>28.000 TL Meta (%15)</TableCell>
                    <TableCell>İleri rapor + brand-lift</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>~1.870.000 TL</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Custom</TableCell>
                    <TableCell>Esnek</TableCell>
                    <TableCell>Kombinasyon</TableCell>
                    <TableCell>Özel rapor</TableCell>
                    <TableCell>Bütçenin %15’i Meta</TableCell>
                    <TableCell>—</TableCell>
                    <TableCell>%10 + KDV (mahsup)</TableCell>
                    <TableCell>Belirlenecek</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
            PaperProps={{ sx: { borderRadius: 4, p: 0.5 } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 6 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h5" fontWeight={800}>Alcago Mesafeli Satış Sözleşmesi</Typography>
                    <Chip size="small" label={(new Date()).toLocaleDateString("tr-TR")} />
                </Stack>
                <IconButton aria-label="Kapat" onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {/* Taraflar */}
                <Section title="Taraflar" id="taraflar">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Alcago</Typography>
                    <Box sx={{ mb: 2 }}>
                        <InfoRow label="Unvan" value='Alcago Teknoloji Anonim Şirketi ("Alcago")' />
                        <InfoRow label="MERSİS" value="0050117816000001" />
                        <InfoRow label="Adres" value="İdealtepe Mah. Denizciler Cad. No: 22 İç Kapı No: 4, Maltepe / İstanbul" />
                        <InfoRow label="E-posta" value="destek@alcago.com" />
                        <InfoRow label="Telefon" value="0539 397 13 63" />
                    </Box>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Marka</Typography>
                    <Box>
                        <InfoRow label="Unvan" value={`${markaUnvan} ("Marka")`} />
                        <InfoRow label="MERSİS/Vergi No" value={markaMersisVno} />
                        <InfoRow label="Adres" value={markaAdres} />
                        <InfoRow label="Temsilci" value={markaTemsilciAdSoyad} />
                        <InfoRow label="E-posta" value={markaEposta} />
                        <InfoRow label="Telefon" value={markaTel} />
                    </Box>
                    <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
                        Nitelik: İşbu sözleşme, tacir sıfatıyla hareket eden taraflar arasında mesafeli satış yöntemiyle akdedilmiştir; tüketici mevzuatı uygulanmaz.
                    </Typography>
                </Section>

                <Section title="1. Tanımlar" id="tanimlar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li><strong>Panel:</strong> Alcago’nun internet/mobil tabanlı yönetim sistemi.</li>
                        <li><strong>Paket:</strong> EK-1 ve EK-2’de detayları bulunan bakiye yüklemeli hizmet paketleri.</li>
                        <li><strong>Bakiye:</strong> Yalnızca Alcago hizmetlerinde kullanılabilen dijital kredi; finansal varlık değildir.</li>
                        <li><strong>Hediye Medya:</strong> Paket kapsamında sağlanan ücretsiz görünürlük/reklam imkanları.</li>
                        <li><strong>Fatura:</strong> E-fatura/e-arşiv belgesi.</li>
                    </ul>
                </Section>

                <Section title="2. Konu"><Typography>Markanın panel üzerinden seçtiği paket/paketleri mesafeli satış yöntemiyle satın alması, ödemesi ve kullanımına ilişkin şartlar.</Typography></Section>

                <Section title="3. Satış ve Ödeme">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Ödeme yöntemi: kredi/banka kartı veya havale/EFT.</li>
                        <li>Ödeme altyapısı: Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş.</li>
                        <li>Ödeme sonrası bakiye panel hesabına tanımlanır; e-fatura/e-arşiv düzenlenir.</li>
                    </ul>
                </Section>

                <Section title="4. Paketlerin Teslim Şekli">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Fiziksel teslimat yoktur.</li>
                        <li>İfa, bakiyenin tanımlanması ve hakların sağlanmasıyla gerçekleşir.</li>
                        <li>Teslim anı, ödeme onayı/bakiye yükleme anıdır.</li>
                    </ul>
                </Section>

                <Section title="5. Cayma Hakkı ve İade">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>B2B niteliktedir; 6502 sayılı Kanun uygulanmaz.</li>
                        <li>Bakiyeler yüklendikten sonra cayma hakkı yoktur; iade edilmez.</li>
                        <li>İptal yalnızca hizmetin ifa edilmemesi halinde mümkündür.</li>
                    </ul>
                </Section>

                <Section title="6. Fiyatlar ve Vergiler">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Fiyatlar KDV hariçtir ve panelde ilan edilir; ödeme anındaki fiyat geçerlidir.</li>
                        <li>Fiyatlar önceden haber verilmeksizin güncellenebilir.</li>
                        <li>Faturalandırma TL cinsindendir.</li>
                    </ul>
                </Section>

                <Section title="7. Marka’nın Yükümlülükleri">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Panel bilgilerini doğru tutmak.</li>
                        <li>Bakiyeyi yalnız kendi kampanyaları için kullanmak; devretmemek.</li>
                        <li>KVKK, Fikri Mülkiyet ve reklam mevzuatına aykırı içerik kullanmamak.</li>
                    </ul>
                </Section>

                <Section title="8. Alcago’nun Yükümlülükleri">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Paket kapsamındaki bakiye ve hizmetleri zamanında sağlamak.</li>
                        <li>Mevzuata uygun fatura düzenlemek.</li>
                        <li>Panelin makul erişilebilirliğini sağlamak.</li>
                    </ul>
                </Section>

                <Section title="9. Sorumluluğun Sınırlandırılması">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Teknik aksaklıklardan sınırlı sorumluluk.</li>
                        <li>Sorumluluk üst sınırı: satın alınan paket bedeli.</li>
                        <li>Dolaylı zarar/kar kaybı/itibar kaybı kapsam dışı.</li>
                    </ul>
                </Section>

                <Section title="10. Mücbir Sebep" />

                <Section title="11. Fesih">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Yeni paket alımı durdurulabilir.</li>
                        <li>Alınmış paket/bakiye iptal edilmez, iade edilmez.</li>
                        <li>Aykırılık halinde Alcago derhal feshedebilir.</li>
                    </ul>
                </Section>

                <Section title="12. Bildirim ve Elektronik Delil">
                    <Typography>Bildirimler e-posta ve panel üzerinden yapılır; panel kayıtları ve e-posta yazışmaları kesin delildir.</Typography>
                </Section>

                <Section title="13. Hukuk ve Yetki">
                    <Typography>Türk hukuku uygulanır; İstanbul (Çağlayan) Merkez Mahkemeleri ve İcra Daireleri yetkilidir.</Typography>
                </Section>

                <Section title="14. Elektronik Onay">
                    <Typography>Marka, panelde onaylayarak tüm şartları kabul eder; bu onay ıslak imza hükmündedir.</Typography>
                </Section>

                {/* EKLER */}
                <Section title="EK-1: Perakende Paketleri">{Ek1Perakende}</Section>
                <Section title="EK-2: Fırsat / Lokal Paketleri">{Ek2Lokal}</Section>

                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                    <Button variant="outlined" onClick={onClose}>Kapat</Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
